import(/* webpackMode: "eager", webpackExports: ["MainProviders"] */ "/home/runner/work/play-web/play-web/web/apps/offspring/src/app/providers.tsx");
